/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAppointments } from 'app/shared/model/appointments.model';
import { IPaymentScheme } from 'app/shared/model/payment-scheme.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { OrderStatus } from 'app/shared/model/enumerations/order-status.model';
import { ProcedureStatus } from 'app/shared/model/enumerations/procedure-status.model';

export interface IOpProcedureOrder {
  id?: string;
  active?: boolean | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  lastUpdated?: number | null;
  cursor?: number | null;
  totalCost?: number | null;
  notes?: string | null;
  orderStatus?: keyof typeof OrderStatus | null;
  billed?: boolean | null;
  procedureStatus?: keyof typeof ProcedureStatus | null;
  appointment?: IAppointments | null;
  scheme?: IPaymentScheme | null;
  patient?: IGlucoUser;
  issuedBy?: IDoctor;
}

export const defaultValue: Readonly<IOpProcedureOrder> = {
  active: false,
  billed: false,
};
